var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tag_g",class:[_vm.isBorder ?
  (_vm.type === _vm.BADGE_TYPE.WHITE_RED || _vm.type === _vm.BADGE_TYPE.WHITE_GRAY) ? 'type_none' : null
  : null,
  _vm.type]},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }